import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { FileUploadModule } from 'ng2-file-upload';

import { CommonImagesModule } from 'src/app/pages/common-images/common-images.module';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { SimpleDynamicComponentModule } from 'src/app/shared/simple-form/simple-dynamic-component.module';

import { AfterSalesPipelineTrackerComponent } from './after-sales-pipeline-tracker.component';
import { SubStatusUpdateDialogComponent } from './sub-status-update-dialog.component';
import { AfterSalesDocumentUploadComponent } from './after-sales-document-upload/after-sales-document-upload.component';

@NgModule({
  declarations: [
    AfterSalesPipelineTrackerComponent,
    SubStatusUpdateDialogComponent,
    AfterSalesDocumentUploadComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CustomFlexLayoutModule,
    FileUploadModule,
    CommonImagesModule,
    CommonFileUploadModule,
    SharedModule,
    SimpleDynamicComponentModule
  ],
  exports: [
    AfterSalesPipelineTrackerComponent,
    SubStatusUpdateDialogComponent,
    AfterSalesDocumentUploadComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class AfterSalesPipelineTrackerModule { }

